/*
* Experiment IDs from google optimize a/b/n tests
*/

export const APPT_BOOK_ON_CALENDAR = process.env.ENV === 'prod' ? 'dehaQp85TCuySb_N7XYSXw' : 'oSQDnTncSHioWRMYG0o2GA';
